import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { AddIcon } from 'assets/materialIcons/materialIcons';
import { Link } from 'react-router-dom';

const CreateButton = (props) => {
    const {
        link,
        basePath,
        label,
        translate,
    } = props;

    const defaultLinkStyle = {
        textDecoration: 'none',
        display: 'inline-flex',
        cursor: 'pointer',
    };

    const path = link || `/${ basePath }/create`;

    return (
        <Link to={ path } style={ defaultLinkStyle }>
            <Button
                icon={ <AddIcon color={ theme.palette.doveGray }/> }
                title={ label || translate('actions.create') }
                primary={ false }
            />
        </Link>
    );
};

CreateButton.propTypes = {
    basePath: PropTypes.string,
    label: PropTypes.string,
    link: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

export default translate(CreateButton);



// WEBPACK FOOTER //
// ./src/components/button/CreateButton.js